<template>
	<page-container :page="page">
		<main-content :title="page.title || page.header" :content="page.content">
			<template #extra-content>
				<div class="columns column12">
					<recursive-sitemap v-if="sitemap" :items="sitemap" />
				</div>
			</template>
		</main-content>
	</page-container>
</template>

<script setup lang="ts">
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: sitemap } = await useWebsiteFetch<SitemapItem[]>('sitemap', {
	query: { language: locale.value },
	key: `${locale.value}/sitemap`,
});
</script>
